import React from 'react'

import theme from 'theme'

export default function ErrorMessage(props: React.HTMLProps<HTMLElement>) {
  return (
    <section
      css={{
        color: theme.colors.red[0],
        fontSize: theme.fontSizes[2]
      }}
      {...props}
    />
  )
}
